import type { AtlasCamera, AtlasProgress, AtlasScope } from "./student-atlas";

/** Положение карты переживает разбор, тренажёр и зачёт. Прогресс хранится отдельно. */
export interface StudentAtlasMemory {
  selected: string | null;
  scope: AtlasScope;
  section: string | null;
  list: boolean;
  history: string[];
  camera: AtlasCamera | null;
  equationMethods?: boolean;
  equationMethodId?: string;
}

export function newAtlasMemory(skillId: string | null): StudentAtlasMemory {
  return { selected: skillId, scope: skillId ? "near" : "all", section: null, list: false, history: [], camera: null };
}

export function atlasActions(entry: AtlasProgress["catalog"][number] | undefined) {
  return {
    theory: entry?.theory === true,
    drill: entry?.covered === true,
    practice: entry?.covered === true && entry.open,
    testout: entry?.covered === true && !entry.credited,
  };
}

export function atlasEntrySkill(lastSkillId: string | null, chosenSkillId: string | null, opened: string[]): string | null {
  return lastSkillId ?? chosenSkillId ?? opened.at(-1) ?? null;
}
